<template>
  <div class="not-found">
    <AntResult
      status="404"
      title="404"
      subTitle="Sorry, the page you visited does not exist."
    />
  </div>
</template>

<script>
import { Result as AntResult } from 'ant-design-vue'

export default {
  name: 'NotFound',
  components: {
    AntResult,
  },
}
</script>

<style scoped>
.not-found {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
